import { render } from "./TextAreaInput.vue?vue&type=template&id=c2a38ed8"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__